module.exports = __webpack_public_path__ + "img/iona.219e7d06.png";